import {Component, Input, OnInit, AfterViewInit, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {BaseListComponent} from '../BaseListComponent/base-list.component';
import {MatSort} from '@angular/material/sort';
import {merge} from 'rxjs/observable/merge';
import {LogService} from '../../services/log.service';
import {LogDataSource} from '../../model/DataSources/LogDataSource';
import {Log} from '../../model/Entities/Log';
import {Pagination} from '../../model/Helpers/Pagination';
import {SortInfo} from '../../model/Helpers/SortInfo';
import {Filter} from '../../model/Helpers/Filter';

@Component({
    selector: 'app-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.scss']
})
export class LogsComponent extends BaseListComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() objectType: string;
    @Input() objectId: number;

    displayedColumns: string[] = [
        'created_at',
        'user',
        'object_action',
        'data'
    ];

    actions = [
        {value: 'send', viewValue: 'Odeslání'},
        {value: 'created', viewValue: 'Vytvoření'},
        {value: 'updated', viewValue: 'Upravení'},
        {value: 'deleted', viewValue: 'Smazání'},
    ];

    @ViewChild(MatSort) sort: MatSort;
    logDataSource: LogDataSource;

    constructor(private logService: LogService) {
        super();
        this.logDataSource = new LogDataSource(this.logService);
        this.dataSource = this.logDataSource as any;
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes.objectType && !changes.objectType.firstChange) ||
            (changes.objectId && !changes.objectId.firstChange)) {
            if (this.objectType && this.objectId) {
                this.logDataSource.setObjectParams(this.objectType, this.objectId);
                if (this.paginator && this.sort) {
                    this.loadData();
                }
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.objectType && this.objectId) {
            this.logDataSource.setObjectParams(this.objectType, this.objectId);
            this.prepareDataLoading();
            this.loadData();
        }
    }

    prepareDataLoading(): void {
        merge(
            this.paginator.page,
            this.sort.sortChange,
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.logDataSource || !this.objectType || !this.objectId) {
                return;
            }
            this.logDataSource.loadPage(
                new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                new SortInfo(this.sort.active, this.sort.direction),
                this.getFilters(),
                {
                    expand: 'user'
                }
            );
        });
    }

    loadData(): void {
        if (!this.objectType || !this.objectId || !this.paginator) {
            return;
        }

        this.logDataSource.loadPage(
            new Pagination(
                this.paginator.pageSize,
                this.pageSize * this.initialPageIndex
            ),
            this.sort ? new SortInfo(this.sort.active, this.sort.direction) : null,
            this.getFilters(),
            {
                expand: 'user'
            }
        );
    }

    getFilters(): Filter[] {
        const filters: Filter[] = [];
        return filters;
    }

    reloadPage(): void {
        super.reloadPage();
    }

    getActionLabel(action: string): string {
        if (!action) {
            return action;
        }

        const actionMap = this.actions.find(a => a.value === action);
        return actionMap ? actionMap.viewValue : action;
    }
}



// WEBPACK FOOTER //
// /app/src/SharedModule/LogsComponent/logs.component.ts